export default "__VITE_ASSET__CRCNAIZk__"